import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import './MetricsCard.css';

const MetricsCard = ({ title, value, change }) => {
  const isPositive = change >= 0;
  
  return (
    <div className="metrics-card">
      <h3>{title}</h3>
      <div className="value">{value}</div>
      <div className={`change ${isPositive ? 'positive' : 'negative'}`}>
        {isPositive ? <FaArrowUp /> : <FaArrowDown />}
        {Math.abs(change)}%
      </div>
    </div>
  );
};

export default MetricsCard; 